var map = {
	"./activities.png": "7e4a",
	"./calendar.png": "6c68",
	"./demo.png": "694c",
	"./en-US.png": "097c",
	"./fireworks.png": "12a3",
	"./he-IL.png": "620a",
	"./orders.png": "798c",
	"./ru-RU.png": "160a",
	"./telegram-icon.png": "8177",
	"./telegram.png": "63ef",
	"./violet.png": "653f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";